module.exports = function BwsBotService() {
    var service = {
        chatWithBot: null // This will be set by the bws-bot directive
    };
    return service;
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/bwsbot/bws-bot-service.js
 **/